import { FC, useMemo, useState } from 'react';
import { useRequest } from '@@/plugin-request/request';
import { getExerciseCategoryTree } from '@/services/ConsoleRequest';
import { TreeSelect } from 'antd';
import { ExerciseCategoryObj } from '@/types/console/exerciseCatrgory';

type TDataSourceObj = {
  key: string;
  value: string;
  title: string;
  children: TDataSourceObj[];
};

type TExerciseTreeCom = {
  onChange?: (ids: string[]) => void;
  value?: any;
};

const ExerciseTreeCom: FC<TExerciseTreeCom> = (props) => {
  const [searchValue, setSearchValue] = useState('');
  const { onChange, value } = props;
  const { data } = useRequest(() => {
    return getExerciseCategoryTree();
  });

  function filterDeep(items: any[], substring: any, mode: 'name' | 'id' | 'ids' = 'name') {
    if (Array.isArray(items)) {
      return items.reduce((accumulator, item) => {
        if (mode === 'name') {
          if (item.title.indexOf(substring) > -1) {
            // 如果当前项的name包含子字符串，则包含整个项
            accumulator.push(item);
          }
        } else if (mode === 'id') {
          if (Number(item.id) === Number(substring)) {
            // 如果当前项的name包含子字符串，则包含整个项
            accumulator.push(item);
          }
        } else if (mode === 'ids') {
          if (substring.includes(item.id)) {
            accumulator.push(item);
          }
        }
        // 如果当前项有children，递归调用filterDeep
        if (item.children && item.children.length) {
          const filteredChildren = filterDeep(item.children, substring, mode);
          if (filteredChildren.length) {
            accumulator.push({ ...item, children: filteredChildren });
          }
        }
        return accumulator;
      }, []);
    }
    return [];
  }

  const dataSource = useMemo(() => {
    const initArray = data?.questionBankCategories;
    if (Array.isArray(initArray)) {
      const mapData = () => {
        const fun = (tempArray: ExerciseCategoryObj[]): TDataSourceObj[] => {
          return tempArray.map((item) => ({
            key: item.id,
            value: item.id,
            title: item.name,
            children: Array.isArray(item.children) ? fun(item.children) : [],
          }));
        };
        return fun(initArray);
      };
      return mapData();
    }
    return [];
  }, [data]);
  const filterSourceData = useMemo(() => {
    if (!searchValue) {
      return dataSource;
    }
    return filterDeep(dataSource, searchValue);
  }, [searchValue, dataSource]);

  console.log('filterSourceData是', filterSourceData);
  return (
    <TreeSelect
      defaultValue={value}
      showSearch
      onSearch={(value) => {
        setSearchValue(value);
      }}
      filterTreeNode={false}
      style={{ width: '100%' }}
      dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
      placeholder="请选择题目分类"
      allowClear
      multiple
      // treeDefaultExpandAll
      treeData={filterSourceData}
      onChange={onChange}
    />
  );
};
export default ExerciseTreeCom;
